import { SERVICES } from '@/constants/services'

export const GUEST_COUNT_OPTIONS: Array<string> = [
    "Under 100",
    "100 to 250",
    "250 to 500",
    "500 to 1,000",
    "More than 1,000"
]

export const BUDGET_OPTIONS: Array<string> = [
    "Under ₹50 lakh",
    "₹50 lakh to ₹1 crore",
    "₹1 to 2 crore",
    "₹2 to 5 crore",
    "Above ₹5 crore",
    "Still working it out"
]

export const NOT_SURE_SERVICE = "Not sure yet"

export const SERVICE_OPTIONS: Array<string> = [
    ...SERVICES.map(service => service.name),
    NOT_SURE_SERVICE
]

export const EVENT_OPTIONS: Array<string> = [
    "Roka or engagement",
    "Haldi",
    "Mehendi",
    "Sangeet",
    "Wedding ceremony",
    "Reception",
    "After-party"
]

export const HEARD_FROM_OPTIONS: Array<string> = [
    "Instagram",
    "A friend or family member",
    "A venue or vendor",
    "Google search",
    "A wedding blog or magazine",
    "Somewhere else"
]
